import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useResource } from "@rest-hooks/core";
import { Typography, Paper, makeStyles } from "@material-ui/core";
import { CustomerSignatureInfoResource } from "@ploy-lib/rest-resources";
import DOMPurify from "dompurify";
const useStyles = makeStyles((theme) => ({
    signerStatusMessage: {},
    customerSignersOuterWrapper: {
        margin: theme.spacing(1),
        padding: theme.spacing(1)
    },
    customerSignersInnerWrapper: {
        "& table": {
            width: "100%"
        }
    }
}), { name: "DployAppSignatureInfo" });
function AppSignatureInfo(props) {
    const { applicationNumber, hideSignerList, signerType } = props;
    const classes = useStyles();
    const customerSignatureInfo = useResource(CustomerSignatureInfoResource.detail(), !applicationNumber ? null : { applicationNumber, signerType });
    return customerSignatureInfo != null ? (_jsxs("div", { children: [_jsx(Typography, { className: classes.signerStatusMessage, children: customerSignatureInfo.signerStatusMessage }), !hideSignerList && customerSignatureInfo.customerSignersHTML && (_jsx(Paper, { className: classes.customerSignersOuterWrapper, children: _jsx("div", { className: classes.customerSignersInnerWrapper, dangerouslySetInnerHTML: {
                        __html: DOMPurify.sanitize(customerSignatureInfo.customerSignersHTML)
                    } }) }))] })) : null;
}
AppSignatureInfo.displayName = "DployAppSignatureInfo";
export { AppSignatureInfo };
//# sourceMappingURL=AppSignatureInfo.js.map